/**
 * Brand logo — matches mobile welcome screen (Unkempt, Healthy Pet).
 */

import {
  LogoContainer,
  LogoSubtitle,
  LogoTitleAccent,
  LogoTitlePrimary,
  LogoTitleRow,
} from './brandLogo.styles';

export default function BrandLogo({ size = 'md', align = 'center' }) {
  return (
    <LogoContainer $align={align}>
      <LogoTitleRow>
        <LogoTitlePrimary $size={size}>Healthy </LogoTitlePrimary>
        <LogoTitleAccent $size={size}>Pet</LogoTitleAccent>
      </LogoTitleRow>
      <LogoSubtitle $size={size} $align={align}>
        Health Hub &amp; Tracker
      </LogoSubtitle>
    </LogoContainer>
  );
}
